import React from "react";

import * as m from "@/shared/styles/main.module.scss";
import loaderGif from "../../assets/images/loader.gif";

interface LoaderProps {
  show: boolean;
}

const Loader: React.FC<LoaderProps> = ({ show }) =>
  show ? (
    <>
      <div className={m.loaderBackground}></div>
      <div className={m.popupLoader}>
        <div className={m.loader}>
          <img src={loaderGif} alt="Loading" />
        </div>
        <p>
          <strong>Processing...</strong>
        </p>
        <p>(This may take a minute to complete)</p>
      </div>
    </>
  ) : null;

export default Loader;
